<!--  -->
<template>
  <div class="child-box" style="height:25%">
    <div class="child-head">
      <div class="child-name">车辆监控</div>
    </div>
    <div class="content" ref="mycharOne"></div>
    <div class="bottom">
      <div class="bottom-left">
        <div class="top">
          <div class="top-item" style="width:39%">3辆</div>
          <div class="top-item" style="width:21%">4辆</div>
          <div class="top-item" style="width:40%">5辆</div>
        </div>
        <div class="dbx"></div>
        <div class="leftb">
          <div class="top-item" style="width:39%">第一车道</div>
          <div class="top-item" style="width:21%">第二车道</div>
          <div class="top-item" style="width:40%">第三车道</div>
        </div>
      </div>
      <div class="bottom-right">交通量</div>
    </div>
  </div>
</template>

<script>
import { optiontwo } from "../utils/echarts";
import { EleResize } from "../utils/esresize";
export default {
  data() {
    return {};
  },

  components: {},

  computed: {},

  mounted() {
    this.drawLine();
  },

  methods: {
    drawLine() {
      let option = optiontwo();
      let myChart = this.$echarts.init(this.$refs.mycharOne);
      myChart.setOption(option);
      let listener = function() {
        myChart.resize();
      };
      EleResize.on(this.$refs.mycharOne, listener);
    }
  }
};
</script>
<style lang="less" scoped>
.content {
  width: 100%;
  height: 50%;
  margin-top: 15px;
}
.bottom {
  width: 100%;
  height: 40px;
  // background: red;
  color: #bcdeff;
  display: flex;
  margin-left: 5px;
  align-items: center;
  .bottom-left {
    width: 84%;
    .top {
      font-size: 14px;
      display: flex;
      text-align: center;
      .top-item{
        width: 35%;
        
      }
    }
    .dbx {
      margin-top: 4px;
      margin-bottom: 4px;
      width: 100%;
      height: 8px;
      background: url(../assets/dbx.png);
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }
    .leftb {
      text-align: center;
      font-size: 10px;
      display: flex;
    }
  }
  .bottom-right{
    font-size: 10px;
    position: absolute;
    right: 15px;
  }
}
</style>